import Avatar from "@mui/material/Avatar";
import defaultImage from "../../../assets/images/expert/default_profle_image.png";
import Box from "@mui/material/Box";
import {
  contactCardContainer,
  contactCardContent,
  contactCardHeader,
} from "./style";
import Chip from "@mui/material/Chip";
import ContactCardMenu from "./menu";
import callIcon from "../../../assets/images/expert/call_expert.png";
import letterIcon from "../../../assets/images/expert/letter_expert.png";
import { contactData } from "../../../organisms/contacts/allContacts/types";
import { useLocation } from "react-router-dom";
import { BoxFlex } from "../../../atoms/boxSpaceBtw";
import { ProjectStats } from "../../client-card/helper";
import Stack from "@mui/material/Stack";
import { AppRoutes } from "../../../constants";
import { Tooltip } from "@mui/material";
import { useSnackbar } from 'notistack';
import "../../../atoms/profile-cardV1/style.scss"
import { handleCopy } from '../../expert-profile-sections/profile-section/helper';
import { isSuperAdmin } from "../../../utils/role";

type Props = {
  data: contactData;
  openEditContact: (id: number) => void;
};

const ContactCard = ({ data , openEditContact}: Props) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const company = queryParams.get("name");
  const { enqueueSnackbar } = useSnackbar();
  return (
    <Box sx={contactCardContainer}>
      <Box sx={contactCardHeader}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Avatar className="img" src={defaultImage} sx={{ width: '50px !important', height: '50px !important' }} />
          <Box sx={{ display: "flex", flexDirection: "row", ml: 1}}>
            <Box sx={{ display: "flex", alignItems: "center", flexDirection: 'column', marginRight: '15px' }}>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}> <p className="name" style={{ marginRight: "0.5rem" }}>{data.name}</p>
                <p className="small" style={{ color: '#ec9324', fontSize: '14px', marginTop:'2px'}}>#{data.id}</p></Box>
              <Box sx={{display:'flex', gap:'10px'}} >
                <p className="small">{data.designation}</p>
              </Box>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: "0.25rem" }}>
              <Tooltip title="Active" arrow>
                <Chip
                  avatar={
                    <span style={{ marginLeft: '18px', marginTop:'0.5px',fontSize: "10px", fontWeight: "700", color: "white"}}>A</span>
                  }
                  sx={{
                    backgroundColor: "#4f7942",
                    width: "17px",
                    height: "17px",
                    borderRadius: "100%",
                    marginTop:'8px',
                    "&:hover": {
                      backgroundColor: "green",
                    },
                  }}
                />
              </Tooltip>
              {data.is_compliance_officer && (
                <Tooltip title="Compliance Officer" arrow>
                  <Chip
                    avatar={<span style={{ marginLeft: '17.75px',marginTop:'1px', fontSize: "10px", fontWeight: "700", color: "white" }}>C</span>}
                    sx={{
                      backgroundColor: "var(--primary-color)",
                      width: "17px",
                      height: "17px",
                      borderRadius: "100%",
                      marginTop:'8px',
                      "&:hover": {
                        backgroundColor: "var(--primary-color)",
                      },
                    }}
                  />
                </Tooltip>
              )}
            </Box>
         </Box>
        </Box>
        <ContactCardMenu contact_email={data.email} openEditContact={() => openEditContact(data.id)} />
      </Box>
      <Box sx={contactCardContent}>
        <BoxFlex sx={{ flexDirection: "column", alignItems: "flex-start", gap: "0.25rem", mb: '1rem' }}>
          <div className="iconContainer" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Tooltip title="Copy email" arrow>
              <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer',gap:'5px' }} onClick={() => handleCopy(data.email, enqueueSnackbar, 'Email')}>
                <img src={letterIcon} className="icon" alt="letter icon" />
                <p className="small">{data.email}</p>
              </div>
            </Tooltip>
            <Tooltip title="Copy mobile number" arrow>
              <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer',gap:'5px' }} onClick={() => handleCopy(data.mobile, enqueueSnackbar, 'Mobile Number')}>
                <img src={callIcon} className="icon rotate" alt="call icon" />
            <p className="small ">{data.mobile}</p>
              </div>
            </Tooltip>
          </div>
        </BoxFlex>
        <div className="separator" />
        <Stack justifyContent={"space-between"} direction="row">
          <ProjectStats
            title={"Total Projects"}
            text={data.total_projects ? data.total_projects.split(",").length : "0"}
            link={data.total_projects ? `${AppRoutes.PROJECTS}/all?page=1&client_projects=${data.total_projects}` : undefined}
          />
          <ProjectStats
            title={"Serviced Projects"}
            text={data.serviced_projects ? data.serviced_projects.split(",").length : "0"}
            link={data.serviced_projects ? `${AppRoutes.PROJECTS}/all?page=1&client_projects=${data.serviced_projects}` : undefined}
          />
          <ProjectStats
            title={"Calls Taken"}
            text={data.calls_taken ? data.calls_taken.split(",").length :  "0"}
            link={data.calls_taken ? `${AppRoutes.CALLS}?call_ids=${data.calls_taken}` : undefined}
          />
          {isSuperAdmin()? 
          <ProjectStats
            title={"Revenue Done"}
            text={data?.revenue_done === '0' ? "0" : `$ ${Math.round(parseFloat(data?.revenue_done))}`}
          />:<></>} 
        </Stack>
      </Box>
    </Box>
  );
};

export default ContactCard;
